module.exports = __webpack_public_path__ + "img/rivne.345253de.png";